import { useState } from "react";
import { Configuration, OpenAIApi } from "openai";
import Footer from "./footer";

function App() {
  const configuration = new Configuration({
    apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  });
  const openai = new OpenAIApi(configuration);

  const [prompt, setPrompt] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const response = await openai.createCompletion({
        model: "text-davinci-003",
        prompt: prompt,
        temperature: 0.5,
        max_tokens: 100,
      });
      setResult(response.data.choices[0].text);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <div className=" bg-white max-h-screen overflow-y-auto grid items-center">
      <div className="mockup-phone bg-white ">
        <div className="camera text-blue-400 text-center p-1 text-l">
          Hi there!
        </div>
        <div className="display  ">
          <div className="phone-1 w-full text-red-500 m-100">
            <p className=" text-6xl text-center leading-none text-blue-900 m-10 ">
              React-OpenAI
            </p>
          </div>
        </div>
        <div>
             <p className="text-gray-800 text-lg">
                Do you have any questions? Let's dive in.🚀
              </p>
        
          <div class="card-body">
              <p className="text-blue-600  text-lg bg-red text-center">{result}</p>
          </div>

          <div class="card w-full text-gray-800">
              <textarea
                type="text"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                placeholder="Type your question here.."
                className="m-10 textarea textarea-bordered border-green-200"
              ></textarea>

              <button
                    onClick={handleClick}
                    disabled={loading || prompt.length === 0}
                    className="btn text-white">
                    {loading ? "Generating..." : "Click Send"}
              </button>

            </div>
         </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
